export const urls = {
  GET_DNEVNIK: 'DnevnikKomisije/vrati_dnevnik_komisije_za_idDok',
};
